import { Box, Button, Chip, CircularProgress, Tooltip, IconButton, TableRow } from '@mui/material'
import * as React from 'react'
import { StyledTableCell } from '../../../core/StyledTableCell'
import {
	ShiftEndTaskSummary,
	ShiftEndWorkItemsSummary,
} from '../../../../types/Reports/ShiftEnd/ShiftEndWorkItems'
import { formatPercent } from '../../../../services/CommonServices/DataFormatters'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import { useState } from 'react'
import { ProgressDialog } from './ProgressDialog'
import AnimatedNumberField from '../../../core/AnimatedNumberField'
import EditIcon from '@mui/icons-material/Edit'
import { useTokenClaims } from '../../../../security/useTokenClaims'
import { usePermissionContext } from '../../../../security/PermissionContext'

const WorkerSummaryRow = ({
	workItem,
	loadData,
	setTaskToRevert,
	overridingTask,
	setUnitOfMeasure,
}: {
	workItem: ShiftEndWorkItemsSummary
	loadData: () => void
	setTaskToRevert: (task: ShiftEndTaskSummary) => void
	overridingTask: number | null
	setUnitOfMeasure: (unitOfMeasure: string) => void
}) => {
	const [open, setOpen] = useState(false)
	const { hasPermission } = usePermissionContext()
	return (
		<>
			<TableRow key={workItem.workItemId} sx={{ cursor: 'pointer' }}>
				<StyledTableCell>
					{(workItem?.tasks?.length ?? 0) > 0 && (
						<IconButton aria-label='expand row' size='small' onClick={() => setOpen(!open)}>
							{open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
						</IconButton>
					)}
				</StyledTableCell>
				<StyledTableCell align='center'>
					<Chip label={workItem.type} variant={'backlogWorkItem'} />
				</StyledTableCell>
				<StyledTableCell align='left' sx={{ pr: 0 }}>
					{workItem.title.split(' > ').map(
						(wi, index, arr) =>
							index !== arr.length - 1 && (
								<>
									{index + 1}. {wi} <br />
								</>
							),
					)}
				</StyledTableCell>
				<StyledTableCell align='center' sx={{ pl: 0 }}>
					{workItem.quantityBudgeted}
				</StyledTableCell>
				<StyledTableCell align='center' sx={{ pl: 0 }}></StyledTableCell>
				<StyledTableCell align='center'>{workItem.burnedHours}</StyledTableCell>
				<StyledTableCell align='center'>
					<AnimatedNumberField value={workItem.performanceFactor} />{' '}
				</StyledTableCell>
				<StyledTableCell align='center'>
					<AnimatedNumberField value={formatPercent(workItem.percentComplete)} />{' '}
				</StyledTableCell>
				<StyledTableCell align='center'>{workItem.budgetedHours}</StyledTableCell>
				<StyledTableCell align='center' sx={{ pl: 0 }}></StyledTableCell>
				<StyledTableCell align='center'>
					<Chip label={workItem.status.replace(/([a-z])([A-Z])/g, '$1 $2')} variant={workItem.status} />
				</StyledTableCell>
			</TableRow>
			{open && (
				<>
					{(workItem.tasks ?? []).map((task: ShiftEndTaskSummary, index) => (
						<TableRow key={index}>
							<StyledTableCell></StyledTableCell>
							<StyledTableCell align='center'>
								<Chip label={task.type} variant={'task'} />
							</StyledTableCell>
							<StyledTableCell align='left' sx={{ pr: 0 }}>
								{task.title}
							</StyledTableCell>
							<StyledTableCell align='center' sx={{ pl: 0 }}></StyledTableCell>
							<StyledTableCell align='center' sx={{ pl: 0 }}>
								<AnimatedNumberField value={task.quantityComplete} />{' '}
							</StyledTableCell>

							<StyledTableCell align='center'>{task.burnedHours}</StyledTableCell>
							<StyledTableCell align='center'></StyledTableCell>
							<StyledTableCell align='center'>
								<AnimatedNumberField value={formatPercent(task.percentComplete)} />
							</StyledTableCell>
							<StyledTableCell align='center'></StyledTableCell>
							<StyledTableCell align='center' sx={{ pl: 0 }}>
								<ProgressDialog
									task={task}
									uom={workItem.unitOfMeasure}
									workItemId={workItem.workItemId}
									loadData={loadData}
									buildSheetRequired={workItem.buildSheetRequired}
								/>
								{task.dayProgress !== 0 && hasPermission(57) && <Tooltip title='Revert Progress'>
									<Button
										variant='contained'
										color='info'
										size='small'
										onClick={() => {
											setTaskToRevert(task)
											setUnitOfMeasure(workItem.unitOfMeasure)
										}}
										disabled={overridingTask === task.id}
										sx={{
											minWidth: 'auto',
											padding: '4px 8px',
											marginLeft: '8px',
										}}
									>
										{overridingTask === task.id ? (
											<CircularProgress size={20} color='inherit' sx={{ m: 0, p: 0 }} />
										) : (
											<EditIcon />
										)}
									</Button>
								</Tooltip>}
							</StyledTableCell>
							<StyledTableCell align='center'>
								<Chip label={task.status} variant={task.status} />
							</StyledTableCell>
						</TableRow>
					))}
				</>
			)}
		</>
	)
}

export default WorkerSummaryRow
